export default "__VITE_IMAGE_ASSET__274e7fc6__";